import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type {
  IApiCreateArticleDraftRequestBody,
  IApiCreateArticleDraftResponseBody,
} from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseCreateArticleDraftMutationValues = {
  appId: string;
  articleId: string;
  body: IApiCreateArticleDraftRequestBody;
};

export const useCreateArticleDraftMutation = (): UseMutationResult<
  IApiCreateArticleDraftResponseBody,
  unknown,
  IUseCreateArticleDraftMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values: IUseCreateArticleDraftMutationValues) =>
      api.articles.createDraft(values.appId, values.articleId, values.body),
  });
};
